export default "__VITE_ASSET__ChgUl$jf__"